import { IQuestionnaire } from '../interfaces/Questionnaire/IQuestionnaire';

/** Only use labels attached to this exact definition/snapshot. No template joins. */
export function localizeQuestionnaire(target: IQuestionnaire, locale: string): void {
  const language = locale.toLowerCase().replace('_', '-').split('-')[0];
  const selected = language === 'el' || language === 'gr' ? 'el' : 'en';
  let available = true;
  let found = false;
  function visit(node: any, root = false): any {
    const copy = { ...node };
    for (const field of ['title', 'text', 'labelTrue', 'labelFalse', 'otherText']) {
      if (typeof node[field] !== 'string' || !node[field]) continue;
      if (root && field === 'title' && !node.displayTranslations?.title) continue;
      found = true;
      const labels = node.displayTranslations?.[field];
      if (labels?.[selected]) copy[field] = labels[selected];
      else {
        available = false;
        copy[field] = labels?.original ?? node[field];
      }
    }
    for (const collection of ['pages', 'elements', 'choices']) {
      if (Array.isArray(node[collection])) copy[collection] = node[collection].map((child: any) => visit(child));
    }
    return copy;
  }
  const localized = visit(target, true);
  target.title = localized.title;
  target.localizationAvailable = available && found;
  // Containers retain pages; child renderers receive updated element references.
  // Form controls, answers, scores and validation state are deliberately untouched.
  target.pages.splice(0, target.pages.length, ...localized.pages);
}
